// SEO Phase 3 — canonical URL resolution for /search results.
//
// A /search?category=X view with no other real filter applied shows
// exactly the same underlying inventory as the canonical /category/:slug
// page, so it canonicalizes there instead of self-canonicalizing to
// /search. Any additional filter (query text, city, price, attributes)
// makes it a distinct result set, so it keeps pointing at /search — the
// same noindex,follow surface the P0 SEO audit already established for
// every other /search variant.
//
// Extracted as a pure function (origin passed in, not read from
// window.location) so it's unit-testable without mounting the full
// SearchResults.js component.
export function resolveSearchCanonical({
  origin,
  category,
  nameToSlug,
  searchQuery,
  city,
  priceMin,
  priceMax,
  attrFilters,
}) {
  const c = String(category || "").trim();
  const slug = c ? nameToSlug?.[c] : null;

  const hasOtherFilters =
    !!String(searchQuery || "").trim() ||
    !!String(city || "").trim() ||
    (priceMin !== "" && priceMin != null) ||
    (priceMax !== "" && priceMax != null) ||
    (attrFilters && Object.keys(attrFilters).length > 0);

  return slug && !hasOtherFilters ? `${origin}/category/${slug}` : `${origin}/search`;
}
